export default {
  'printerLogs.column.id': '任务ID',
  'printerLogs.column.created_at': '任务创建时间',
  'printerLogs.column.device_name': '终端名',
  'printerLogs.column.device_ip': '终端IP',
  'printerLogs.column.app_version': 'App版本号',
  'printerLogs.column.bundle_version': '外带批次号',
  'printerLogs.column.printer_name': '打印机名',
  'printerLogs.column.printer_ip': '打印机IP',
  'printerLogs.column.printer_mac': '打印机MAC',
  'printerLogs.column.printer_mode': '打印机型号',
  'printerLogs.column.fireware': '固件',
  'printerLogs.column.disconnect_type': '断联类型',
  'printerLogs.column.operation_suggestion': '操作建议',
  'printerLogs.column.error_description': '错误描述信息',
  'printerLogs.column.status': '任务状态',
  'printerLogs.column.order_number': '订单号',
  'printerLogs.column.order_source': '订单来源',
  'printerLogs.column.cart_number': '小票号',
  'printerLogs.column.ticket_type': '票据类型',
  'printerLogs.column.trigger': '触发方式',
  'printerLogs.column.trigger_printing_source': '触发源',
  'printerLogs.column.retry_count': '重试次数',
  'printerLogs.column.priority': '优先级',
  'printerLogs.column.template': '打印模板',
  'printerLogs.column.recovery_mode_status': '打印恢复模式',
  'printerLogs.column.external_order_number': '外部订单号',
  'printerLogs.column.external_platform': '平台名',
  'printerLogs.column.service_type': '服务类型',
  'printerLogs.column.template_type': '模板类型',
  'printerLogs.column.rendering_bitmap': '是否以位图显示',
  'printerLogs.column.duration': '用时',
  'printerLogs.column.error_reason': '错误原因',
  'printerLogs.column.error_type': '错误类型',
  'printerLogs.column.error_reason_type': '错误原因类型',
  'printerLogs.column.print_in_background': '是否后台打印',
  'printerLogs.column.firmware': '固件版本',

  'printerLog.title': '打印任务详情',
  'printerLog.section.basicInfos': '基本信息',
  'printerLog.section.ticketInfos': '票据信息',
  'printerLog.section.traces': '打印时间流',

  'printerLogs.status.initial': '待打印',
  'printerLogs.status.printing': '打印中',
  'printerLogs.status.printSuccess': '已完成',
  'printerLogs.status.printFail': '失败',
  'printerLogs.status.expired': '已过期',

  'printerLogs.ticketType.bill': '账单',
  'printerLogs.ticketType.reprintBill': '重打账单',
  'printerLogs.ticketType.receipt': '收据',
  'printerLogs.ticketType.reprintReceipt': '重打收据',
  'printerLogs.ticketType.reprintReceiptCustomerCopy': '重打收据客户联',
  'printerLogs.ticketType.reprintReceiptMerchantCopy': '重打收据商户联',
  'printerLogs.ticketType.reprintReceiptRefund': '退款收据重打',
  'printerLogs.ticketType.kitchenTicket': '厨房单',
  'printerLogs.ticketType.reprintKitchenTicket': '重打厨房单',
  'printerLogs.ticketType.voidKitchenTicket': '作废菜品打厨房单',
  'printerLogs.ticketType.updateKitchenTicket': '修改菜品打厨房单',
  'printerLogs.ticketType.rushKitchenTicket': '催菜打厨房单',
  'printerLogs.ticketType.packingTicket': '外带单',
  'printerLogs.ticketType.reprintPackingTicket': '重打外带单',
  'printerLogs.ticketType.voidPackingTicket': '作废菜品外带单',
  'printerLogs.ticketType.updatePackingTicket': '修改菜品打外带单',
  'printerLogs.ticketType.closeoutReport': '日结单',
  'printerLogs.ticketType.cashDrawerReport': '钱箱小结',
  'printerLogs.ticketType.check': '分单票',
  'printerLogs.ticketType.clockoutSummary': '下班打卡小结',
  'printerLogs.ticketType.giftCardTransaction': '礼品卡交易记录',
  'printerLogs.ticketType.runnerTicket': '跑堂小票',
  'printerLogs.ticketType.reprintRunnerTicket': '重打跑堂小票',
  'printerLogs.ticketType.voidRunnerTicket': '作废跑堂小票',
  'printerLogs.ticketType.updateRunnerTicket': '修改跑堂小票',

  'printerLogs.errorType.printerNotFound': '未搜索到打印机',
  'printerLogs.errorType.printerIsBusy': '打印机正忙',
  'printerLogs.errorType.capabilityNotSupported': '不支持的功能',
  'printerLogs.errorType.paperIsEmpty': '缺纸',
  'printerLogs.errorType.offline': '打印机离线',
  'printerLogs.errorType.connectError': '连接错误',
  'printerLogs.errorType.jobFailed': '打印任务失败',
  'printerLogs.errorType.otherError': '其他错误',
  'printerLogs.errorType.noPrintersConfigure': '未配置打印机',
  'printerLogs.errorType.printersIsInactive': '打印机已冻结',
  'printerLogs.errorType.dishesNoPrintersConfigure': '菜品未配置打印机',
  'printerLogs.errorType.printersInactiveWithMeals': '菜品关联的打印机已冻结',
  'printerLogs.errorType.notConfiguration': '未找到相关的配置',

  'printerLogs.recoveryModeStatus.unused': '未启用',
  'printerLogs.recoveryModeStatus.reportFail': '失败',
  'printerLogs.recoveryModeStatus.reported': '已启用',
  'printerLogs.recoveryModeStatus.success': '成功',
  'printerLogs.recoveryModeStatus.timeout': '超时',

  'printerLogs.errorReasonType.noInterface': '未开启网络',
  'printerLogs.errorReasonType.noWifiAndNoWired': '无wifi/有线网络',
  'printerLogs.errorReasonType.noLocalNetworkPermission': '无本地网络权限',
  'printerLogs.errorReasonType.notConfigPrinters': '未匹配打印机',
  'printerLogs.errorReasonType.printerInfoError': '打印机信息异常',
  'printerLogs.errorReasonType.icmpPingFail': 'ICMP Ping失败',
  'printerLogs.errorReasonType.pingWebFail': 'Ping打印机失败',
  'printerLogs.errorReasonType.noExceptionFound': '未检测到异常',

  'printerLogs.filter.orderNumber': '订单号',
  'printerLogs.filter.ticketNumber': '小票号',

  'PrinterLogDetail.section.orderInfos': '订单信息',
  'PrinterLogDetail.section.taskInfos': '任务信息',
  'PrinterLogDetail.section.deviceInfos': '设备信息',
  'PrinterLogDetail.section.traces': '打印跟踪',
  'PrinterLogDetail.section.template': '模板',
  'PrinterLogDetail.section.operationSuggestion': '建议操作',
};
